<div class="flex flex--center ms-large-r">
  <div class="legend-square ms-xsmall-r nordic-blue-900-bg"></div>
  <div class="font-body-2">{{ text$ | async }}</div>
</div>
